import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';

import { AdditionalInfoItemConfig
       } from 'collage-designer/collage-designer-config';
import { Utils } from 'core/utils';
import { AdditionalInfoItemInterface
       } from './additional-info-item-interface';

@Component({
    selector: 'external-html-content',
    templateUrl: './external-html-content.component.html',
    styleUrls: ['./external-html-content.component.scss'],
    standalone: false
})
export class ExternalHTMLContentComponent
    implements AdditionalInfoItemInterface
{
  public removeComponent: () => void;
  public content: string|undefined;

  constructor (
      private http: HttpClient)
  { }

  /*
   * @throws ExternalHTMLContentLoadingError
   */
  public async initComponent(
      additionalInfoItem: AdditionalInfoItemConfig): Promise<void>
  {
    this.content = <any> await this.http.get(
        additionalInfoItem.location, { responseType: 'text' })
          .pipe(Utils.retryPipe())
          .toPromise()
          .catch((e) => {
            throw new Error(`[${e.status} ${e.statusText}] "${e.url}"`.trim());
          });
  }

  public async isApplyable(): Promise<boolean>
  {
    return true;
  }
}
